import { PlainObject } from 'odata-query';
import { ODataSession } from '../abstractions/odata-session';

export class FilterQueryBuilder {
  filter: Map<string, JSONValue> = new Map();
  skip?: number;
  top?: number;

  constructor(session: ODataSession) {
    if (session.filter) {
      this.filter = new Map(Object.entries(session.filter));
    }

    if (session.skip !== undefined) {
      this.skip = session.skip;
    }

    if (session.top !== undefined) {
      this.top = session.top;
    }
  }

  updateFilter(key: string, value: JSONValue): void {
    this.filter.set(key, value);
  }

  removeFilter(key: string): void {
    this.filter.delete(key);
  }

  updateSkip(skip: number): void {
    this.skip = skip;
  }

  updateTop(top: number): void {
    this.top = top;
  }

  clearFilter(): void {
    this.filter.clear();
  }

  getValue(key: string): JSONValue | undefined {
    return this.filter.get(key);
  }

  toSessionString(): string {
    const json = this.build();
    return JSON.stringify(json);
  }

  toQuery(): PlainObject {
    return this.build();
  }

  build(): PlainObject {
    const storedQuery: Map<string, JSONValue> = new Map();
    let filters: JSONObject = {};

    if (this.filter.size > 0) {
      filters = Object.fromEntries(this.filter);
    }

    if (Object.entries(filters).length > 0) {
      storedQuery.set('filter', filters);
    }

    if (this.skip !== undefined) {
      storedQuery.set('skip', this.skip);
    }

    if (this.top !== undefined) {
      storedQuery.set('top', this.top);
    }

    return Object.fromEntries(storedQuery);
  }
}
